"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TableWidgetContext_1 = require("./TableWidgetContext");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importStar(require("lodash"));
var WidgetManager_1 = require("../../WidgetManager");
var RepeatingTableRow_1 = require("Project/QwilrEditor/Widgets/TableWidget/RepeatingTableRow");
var TableWidgetDimensionToolbar_1 = require("./TableWidgetDimensionToolbar");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var TableWidget_1 = require("./TableWidget");
var TableRowToolbar_1 = require("./TableRowToolbar");
var TableRowContext_1 = require("./TableRowContext");
var TableCellInner = function (_a) {
    var _b;
    var attributes = _a.attributes, children = _a.children, element = _a.element, widgetManager = _a.widgetManager;
    var _c = (0, react_1.useContext)(TableWidgetContext_1.TableWidgetContext), data = _c.data, cellsAreEditable = _c.cellsAreEditable, actions = _c.actions, hoveredColumnForDeletionIdx = _c.hoveredColumnForDeletionIdx, isResizingColumns = _c.isResizingColumns;
    var repeatingRowMenu = (_b = (0, react_1.useContext)(RepeatingTableRow_1.RepeatingTableRowContext)) === null || _b === void 0 ? void 0 : _b.repeatingRowMenu;
    var _d = (0, TableRowContext_1.useTableRowContext)(), _e = _d.state, rowElement = _e.rowElement, rowDeletable = _e.hoverDelete, setHoveringDeleteOnRow = _d.actions.setHoverDelete;
    var cellPath = widgetManager.getPath(element);
    var cellNumber = lodash_1.default.last(cellPath);
    var rowNumber = lodash_1.default.nth(cellPath, -2);
    var inTopRow = rowNumber === 0;
    var firstCellInRow = cellNumber === 0;
    var _f = __read((0, react_1.useState)(false), 2), inColumnActivationZone = _f[0], setInColumnActivationZone = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), inRowActivationZone = _g[0], setInRowActivationZone = _g[1];
    var potentiallyRenderRepeatingRowMenu = function () {
        if (repeatingRowMenu && cellNumber === 0) {
            return repeatingRowMenu;
        }
    };
    var getColumnIndex = function () {
        return lodash_1.default.last(widgetManager.getPath(element));
    };
    return (react_1.default.createElement("td", __assign({}, attributes, { className: (0, classnames_1.default)("table-widget__cell", {
            "table-widget__cell--deletable": getColumnIndex() === hoveredColumnForDeletionIdx || rowDeletable,
        }), contentEditable: cellsAreEditable, suppressContentEditableWarning: true, onMouseMove: function (event) {
            if (isResizingColumns) {
                return;
            }
            if (inTopRow) {
                var rowTop = event.currentTarget.getBoundingClientRect().top;
                var mouseY = event.clientY;
                if (mouseY < rowTop + TableWidgetDimensionToolbar_1.TABLE_WIDGET_DIMENSION_TOOLBAR_ACTIVATION_BUFFER) {
                    setInColumnActivationZone(true);
                }
                else {
                    setInColumnActivationZone(false);
                }
            }
            if (firstCellInRow) {
                var rowLeft = event.currentTarget.getBoundingClientRect().left;
                var mouseX = event.clientX;
                if (mouseX < rowLeft + TableWidgetDimensionToolbar_1.TABLE_WIDGET_DIMENSION_TOOLBAR_ACTIVATION_BUFFER) {
                    setInRowActivationZone(true);
                }
                else {
                    setInRowActivationZone(false);
                }
            }
        }, onMouseLeave: function () {
            (0, lodash_1.delay)(function () {
                setInColumnActivationZone(false);
                setInRowActivationZone(false);
            }, TableWidgetDimensionToolbar_1.TABLE_WIDGET_DIMENSION_TOOLBAR_HIDE_DELAY_MS);
        } }),
        potentiallyRenderRepeatingRowMenu(),
        react_1.default.createElement(TableWidgetDimensionToolbar_1.TableWidgetDimensionToolbar, { inActivationZone: inColumnActivationZone, size: "medium", mode: "column", onDelete: function () {
                actions.deleteColumn(getColumnIndex());
            }, setHoverDelete: function (nextValue) {
                if (nextValue) {
                    actions.hoverColumnForDeletion(getColumnIndex());
                }
                else {
                    actions.hoverColumnForDeletion(undefined);
                }
            }, canAdd: data.columns < TableWidget_1.TABLE_MAX_COLUMNS, canDelete: data.columns !== 1 },
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.ArrowLeft, null), onClick: function () {
                    actions.addColumn(getColumnIndex(), "before");
                } }, "Add column left"),
            react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.ArrowRight, null), onClick: function () {
                    actions.addColumn(getColumnIndex(), "after");
                } }, "Add column right")),
        firstCellInRow && (react_1.default.createElement(TableRowToolbar_1.TableRowToolbar, { inActivationZone: inRowActivationZone, element: rowElement, setHoverDelete: setHoveringDeleteOnRow })),
        children));
};
var TableCell = function (_a) {
    var element = _a.element, attributes = _a.attributes, children = _a.children;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    return react_1.default.createElement(TableCellInner, { element: element, attributes: attributes, children: children, widgetManager: widgetManager });
};
exports.default = TableCell;
